import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    badge: {
        position: 'fixed',
        right: 8,
        // Clear the notch / status bar on iOS
        top: 'calc(8px + env(safe-area-inset-top))',
        zIndex: 99999,
        maxWidth: 'calc(100vw - 16px)',
        padding: '2px 8px',
        borderRadius: 4,
        background: '#b00020',
        color: '#ffffff',
        font: '600 11px/1.5 monospace',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        opacity: 0.85,
        // Never block clicks on whatever is underneath
        pointerEvents: 'none',
    }
}))

/**
 * Shows which branch this build came from. Only rendered when SHOW_BRANCH_NAME is enabled
 * (dev envs and local; off by default).
 */
export const BranchBadge = () => {
    const classes = useStyles()
    const { BRANCH_NAME: branch, SHOW_BRANCH_NAME } = window._env_

    // SHOW_BRANCH_NAME is a runtime opt-in (dev envs and local only; off by default).
    // An unset branch can come through as an empty string or an unsubstituted `$BRANCH_NAME`.
    if (SHOW_BRANCH_NAME !== '1' || !branch || branch.startsWith('$')) {
        return null
    }

    return <div className={classes.badge} data-branch-badge aria-hidden="true">{branch}</div>
}
